import React from "react";
import { useNavigate } from "react-router-dom";
/** Components Import */
import EmptyBox from "../../Components/EmptyBox";
import Card from "../../Components/Card_wrap";
import BasicArea from "../../Components/PDA/BarcodeArea";
import BasicInput from "../../Components/Input_Basic";
import RadioBasic from "../../Components/Radio_Basic";
import CardH3 from "../../Components/Card_H3";
import Snackbar from "../../Components/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight as RightArrows,
  faClipboardCheck as OrderComplete,
  faHourglassHalf as StandBy,
  faBoxOpen as Producted,
  faBox as Packing,
  faTruckArrowRight as Delivery,
} from "@fortawesome/free-solid-svg-icons";
import BasicButton from "../../Components/Button_Basic";
import { useRef } from "react";
function MM10060(props) {
  React.useEffect(() => {
    if (document.title === props.inputs.title) {
      const element = document.getElementById("topbar");
      element.innerHTML =
        "<h1>" +
        "<span class='bullet'>" +
        "</span>" +
        "<strong class='depth-1'>" +
        "생산관리" +
        "	</strong>" +
        "<span class='divider' >" +
        "</span>" +
        "<strong'>" +
        props.inputs.title +
        "</strong>" +
        "</h1>";
      return;
    } else {
      document.title = props.inputs.title;
      const element = document.getElementById("topbar");
      element.innerHTML =
        "<h1>" +
        "<span class='bullet'>" +
        "</span>" +
        "<strong class='depth-1'>" +
        "생산관리" +
        "	</strong>" +
        "<span class='divider' >" +
        "</span>" +
        "<strong'>" +
        props.inputs.title +
        "</strong>" +
        "</h1>";
    }
  }, []);
  React.useEffect(() => {
    const HandleEnterKey = (e) => {
      const { key, keyCode } = e;
      if (keyCode === 13) {
        navigator.clipboard.readText().then((clipboardText) => {
          if (
            clipboardText.substring(4, 6) === "WO" &&
            clipboardText.length === 10
          ) {
            props.WoNoSearch(clipboardText);
            props.setSaveWoNo(clipboardText);
          } else if (
            clipboardText.substring(0, 3) === "PRO" &&
            clipboardText.length === 6
          ) {
            props.ProcessCdSearch(clipboardText);
          } else {
            props.UserSearch(clipboardText);
          }
        });
      }
    };
    window.addEventListener("keypress", HandleEnterKey);

    return () => window.removeEventListener("keypress", HandleEnterKey);
  });
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });

  return (
    <div>
      <EmptyBox />
      <BasicArea
        inputValue={props.inputs.barcodeValue}
        onInputChange={(e) => {
          props.setInputs({
            ...props.inputs,
            barcodeValue: e,
          });
        }}
        switchValue={props.inputs.switchValue}
        onSwitchChange={(e) => {
          props.setInputs({
            ...props.inputs,
            switchValue: e,
          });
        }}
        onInputKeyDown={(e) => {
          if (
            props.inputs.barcodeValue.substr(4, 2) === "WO" &&
            props.inputs.barcodeValue.length === 10
          ) {
            props.WoNoSearch();
            props.setSaveWoNo(props.inputs.barcodeValue);
          } else if (
            props.inputs.barcodeValue.substr(0, 3) === "PRO" &&
            props.inputs.barcodeValue.length === 6
          ) {
            props.ProcessCdSearch();
          } else {
            props.UserSearch();
          }
        }}
        inputRef={inputRef}
        autoFocus={true}
      />

      <Card
        wrapStyle={{
          height: "71vh",
          display: "flex",
          flexDirection: "column",
          // justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <RadioBasic
          name="공정:    "
          labelStyle={{
            marginLeft: "10px",
            marginRight: "10px",
            fontSize: "11px",
          }}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-envenly",
            alignItems: "flex-start",
            margin: "5px",
            marginBottom: "10px",
            marginTop: "20px",
          }}
          containerStyle={{
            flexWrap: "noWrap",
            width: "78px",
          }}
          items={props.inputs.startEndRadio}
          value={props.inputs.startEnd}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              startEnd: e.target.value,
            });
            inputRef.current.focus();
          }}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="시작시간"
          value={props.inputs.wkStDt}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              wkStDt: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        {/* <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="종료시간"
          value={props.inputs.wkEdDt}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              wkEdDt: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        /> */}
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="작업지시번호"
          value={props.inputs.woNo}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              woNo: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="작업자"
          value={props.inputs.userNm}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              userNm: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="공정"
          value={props.inputs.workOrderValue}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              workOrderValue: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="최근공정"
          value={props.inputs.currentWorkOrderValue}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              currentWorkOrderValue: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="최근양품수량"
          value={props.inputs.currentWorkOrderQty}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              currentWorkOrderQty: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="품목명"
          value={props.inputs.itemNm}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              itemNm: e.target.value,
            });
            inputRef.current.focus();
          }}
          disabled={true}
        />
        <div
          style={{
            width: "100%",
            padding: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <BasicButton
            style={{
              padding: "10px 15px",
            }}
            name="공정현황(PDA)"
            onClick={() => props.ProcMove()}
          />
        </div>
        {/* <div
          style={{
            width: "100%",
            padding: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <BasicButton
            style={{
              padding: "10px 15px",
            }}
            name="출력"
            onClick={() => props.print()}
          />
        </div> */}
      </Card>

      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default MM10060;
